/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Renders_FailedInputs */

const en_directory_ai_tools_renders_failed = /** @type {(inputs: Directory_Ai_Tools_Renders_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Render failed · credits refunded`)
};

const zh_directory_ai_tools_renders_failed = /** @type {(inputs: Directory_Ai_Tools_Renders_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成失败 · 积分已退还`)
};

/**
* | output |
* | --- |
* | "Render failed · credits refunded" |
*
* @param {Directory_Ai_Tools_Renders_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_renders_failed = /** @type {((inputs?: Directory_Ai_Tools_Renders_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Renders_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_renders_failed(inputs)
	return zh_directory_ai_tools_renders_failed(inputs)
});
export { directory_ai_tools_renders_failed as "directory.ai_tools.renders.failed" }